import { useState } from "react";
import { useAuth } from "@/providers/AuthProvider";
import { PageHeading } from "./ui/page-heading";
import { PageContent } from "./ui/page-content";
import { Button } from "./ui/button";
import { PlusIcon } from "lucide-react";
import { Card, CardContent } from "./ui/card";
import { CreateTeamDialog } from "./teams/CreateTeamDialog";
import { TeamCard } from "./teams/TeamCard";
import { useNavigate } from "react-router";

export function Teams() {
  const { teams, refetchGeneralData } = useAuth();
  const navigate = useNavigate();
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);

  const hasTeams = teams && teams.length > 0;

  const handleTeamCreated = async () => {
    setIsCreateDialogOpen(false);
    await refetchGeneralData?.();
    if (!hasTeams) {
      navigate("/assessments");
    }
  };

  return (
    <>
      <PageHeading>{hasTeams ? "Teams" : "Let's get started"}</PageHeading>
      <PageContent>
        {hasTeams && (
          <div className="flex justify-between items-center mb-6">
            <div>
              <p className="text-muted-foreground">
                Manage your teams and team members
              </p>
            </div>
            <Button onClick={() => setIsCreateDialogOpen(true)}>
              <PlusIcon className="h-4 w-4 mr-2" />
              Create team
            </Button>
          </div>
        )}

        {hasTeams ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {teams.map((team) => (
              <TeamCard key={team.id} team={team} />
            ))}
          </div>
        ) : (
          <Card>
            <CardContent>
              <p className="text-muted-foreground my-4">
                Create your first team to get started.
              </p>
              <Button onClick={() => setIsCreateDialogOpen(true)}>
                <PlusIcon className="h-4 w-4 mr-2" />
                Create team
              </Button>
            </CardContent>
          </Card>
        )}
      </PageContent>

      <CreateTeamDialog
        open={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
        onTeamCreated={handleTeamCreated}
      />
    </>
  );
}
